function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 491",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-10.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,10.667C114.56,10.667 0,123.307 0,262.229C0,373.397 73.344,467.669 175.04,500.907C187.84,503.275 192.533,495.488 192.533,488.811C192.533,482.837 192.32,467.008 192.213,446.037C121.003,461.205 105.984,412.288 105.984,412.288C94.336,383.253 77.504,375.488 77.504,375.488C54.315,359.893 79.296,360.213 79.296,360.213C105.003,361.963 118.507,386.133 118.507,386.133C141.333,424.597 178.432,413.483 193.067,407.061C195.371,390.784 201.963,379.712 209.28,373.419C152.427,367.125 92.672,345.493 92.672,249.109C92.672,221.653 102.592,199.211 119.019,181.611C116.139,175.253 107.499,149.675 121.259,115.029C121.259,115.029 142.699,108.288 191.659,140.821C212.139,135.232 233.899,132.459 255.659,132.331C277.419,132.459 299.179,135.232 319.659,140.821C368.299,108.288 389.739,115.029 389.739,115.029C403.499,149.675 394.859,175.253 392.299,181.611C408.619,199.211 418.539,221.653 418.539,249.109C418.539,345.749 358.699,367.019 301.739,373.205C310.699,380.757 319.019,396.181 319.019,419.755C319.019,453.419 318.699,480.469 318.699,488.64C318.699,495.232 323.179,503.104 336.299,500.587C438.72,467.563 512,373.227 512,262.229C512,123.307 397.376,10.667 256,10.667Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.6053beb2.svg";
export { ForwardRef as ReactComponent };